import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-start gap-3 rounded-[10px] border border-gray-200 bg-white p-3 transition hover:border-gray-300 hover:shadow-sm" }
const _hoisted_2 = { class: "min-w-0 flex-1" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = { class: "mt-2 flex flex-wrap items-center gap-1.5" }
const _hoisted_6 = {
  "data-chip": "type",
  class: "rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-semibold text-gray-700"
}
const _hoisted_7 = {
  key: 0,
  "data-chip": "unsaved",
  class: "rounded-full bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-700 ring-1 ring-inset ring-amber-200",
  title: "It saves once it has its question text, and options if it is a select."
}
const _hoisted_8 = { class: "flex shrink-0 gap-0.5" }

import { PencilIcon, SparklesIcon, TrashIcon } from '@heroicons/vue/20/solid'
import { Bars3Icon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'

import RequiredSwitch from './RequiredSwitch.vue'


export default {
  __name: 'QuestionCard',
  props: {
  field: { type: Object, required: true },
  typeLabel: { type: String, required: true },
  options: { type: Array, default: () => [] },
  incomplete: { type: Boolean, default: false }
},
  emits: ['edit', 'remove', 'update:required'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const whyOpen = ref(false)

const shownOptions = computed(() => props.options.map(option => option.trim()).filter(Boolean))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Bars3Icon), {
      class: "drag-handle mt-0.5 h-4 w-4 shrink-0 cursor-grab text-gray-300",
      "aria-hidden": "true"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.field.label || 'Untitled question'), 1),
      (__props.field.purpose)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "mt-0.5 flex w-full items-start gap-1.5 text-left text-xs leading-snug text-gray-500 hover:text-gray-700",
            "aria-expanded": whyOpen.value,
            onClick: _cache[0] || (_cache[0] = $event => (whyOpen.value = !whyOpen.value))
          }, [
            _createVNode(_unref(SparklesIcon), {
              class: "mt-px h-3 w-3 shrink-0 text-gray-400",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", {
              class: _normalizeClass(!whyOpen.value && 'line-clamp-1')
            }, _toDisplayString(__props.field.purpose), 3)
          ], 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.typeLabel), 1),
        _createVNode(RequiredSwitch, {
          required: __props.field.required,
          "onUpdate:required": _cache[1] || (_cache[1] = $event => (emit('update:required', $event)))
        }, null, 8, ["required"]),
        (__props.incomplete)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Not saved yet "))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shownOptions.value, (option, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            "data-chip": "option",
            class: "rounded-full bg-white px-2.5 py-0.5 text-xs text-gray-500 ring-1 ring-inset ring-gray-200"
          }, _toDisplayString(option), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        class: "rounded-md p-1.5 text-gray-400 hover:bg-gray-50 hover:text-gray-900",
        "aria-label": "Edit question",
        onClick: _cache[2] || (_cache[2] = $event => (emit('edit')))
      }, [
        _createVNode(_unref(PencilIcon), {
          class: "h-4 w-4",
          "aria-hidden": "true"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "rounded-md p-1.5 text-gray-400 hover:bg-gray-50 hover:text-red-600",
        "aria-label": "Delete question",
        onClick: _cache[3] || (_cache[3] = $event => (emit('remove')))
      }, [
        _createVNode(_unref(TrashIcon), {
          class: "h-4 w-4",
          "aria-hidden": "true"
        })
      ])
    ])
  ]))
}
}

}